// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-map-marker {
  font-family: var(--_18w76bw3n)!important;
  line-height: var(--_18w76bw46);
  margin-bottom: 6px;
  font-weight: var(--_18w76bw42);
  font-size: 17px!important;
}
.info-window-content {
  font-size: var(--_18w76bw3r);
  font-family: var(--_18w76bw3n);
  line-height: 1.13;
  font-weight: var(--_18w76bw3z);
}
.info-window-content .get-directions {
  text-decoration: underline;
  display: block;
  margin-top: var(--_18w76bwb);
}
.info-window-content .get-directions:hover {
  color: var(--_18w76bw2f);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[".store-map-marker {\n  font-family: var(--_18w76bw3n)!important;\n  line-height: var(--_18w76bw46);\n  margin-bottom: 6px;\n  font-weight: var(--_18w76bw42);\n  font-size: 17px!important;\n}\n.info-window-content {\n  font-size: var(--_18w76bw3r);\n  font-family: var(--_18w76bw3n);\n  line-height: 1.13;\n  font-weight: var(--_18w76bw3z);\n}\n.info-window-content .get-directions {\n  text-decoration: underline;\n  display: block;\n  margin-top: var(--_18w76bwb);\n}\n.info-window-content .get-directions:hover {\n  color: var(--_18w76bw2f);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
